<template>
  <div>
    <el-dialog
        :visible.sync="showOnboarding"
        width="50%"
    >
      <el-carousel indicator-position="none" :interval=6000>
        <el-carousel-item>
          <img :src="require(`@/assets/Slideshow BV EC 1.png`)" alt=""/>
        </el-carousel-item>
        <el-carousel-item>
          <img :src="require(`@/assets/Slideshow BV EC 2.png`)" alt=""/>
        </el-carousel-item>
        <el-carousel-item>
          <img :src="require(`@/assets/Slideshow BV EC 3.png`)" alt=""/>
        </el-carousel-item>
      </el-carousel>
      <span slot="footer" class="dialog-footer">
                <el-button @click="showOnboarding = false">{{ $t('posts.dialog.close') }}</el-button>
                <el-button type="primary" @click="updateBVOnboarding">{{
                    $t('posts.dialog.dontDisplayAnymore')
                  }}</el-button>
            </span>
    </el-dialog>
  </div>

</template>

<script>
import ElButton from '../../../../components/Button'
import { Carousel, CarouselItem } from 'element-ui'
import { mapGetters } from 'vuex'

export default {
  name: 'DialogShowOnboardingBV',
  components: {
    ElButton,
    ElCarousel: Carousel,
    ElCarouselItem: CarouselItem
  },
  data () {
    return {
      showOnboarding: true
    }
  },
  computed: {
    ...mapGetters(['getStopPopupBV'])
  },
  methods: {
    updateBVOnboarding () {
      this.$emit('stop-popup-bv')
      this.$store.dispatch('updateBVOnboarding')
      this.showOnboarding = false
    }
  },
  beforeMount () {
    if (this.getStopPopupBV === false) {
      this.showOnboarding = true
    } else {
      this.showOnboarding = false
    }
  }
}

</script>
